import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Wallet } from "lucide-react";

export default function AccountSnapshot() {
  const [state, setState] = useState(null);

  useEffect(() => {
    const load = () => api.get("/portfolio/risk-status").then((r) => setState(r.data)).catch(() => {});
    load();
    const iv = setInterval(load, 15000);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className="vx-card p-5" data-testid="account-snapshot">
      <div className="flex items-center justify-between mb-4">
        <div className="vx-label">Account Snapshot</div>
        <Wallet className="w-3.5 h-3.5 text-[#3b82f6]" />
      </div>
      {!state ? (
        <div className="text-xs text-[#6b7280] font-mono">Loading…</div>
      ) : (
        <dl className="space-y-2 text-xs font-mono">
          <div className="flex justify-between"><dt className="text-[#6b7280]">Balance</dt><dd className="font-bold text-white">${state.balance?.toLocaleString()}</dd></div>
          <div className="flex justify-between"><dt className="text-[#6b7280]">Equity</dt><dd className={state.equity >= state.balance ? "text-[#10b981]" : "text-[#ef4444]"}>${state.equity?.toLocaleString()}</dd></div>
          <div className="flex justify-between"><dt className="text-[#6b7280]">Free margin</dt><dd>${((state.equity || 0) - (state.margin_used || 0)).toLocaleString()}</dd></div>
          <div className="flex justify-between"><dt className="text-[#6b7280]">Positions</dt><dd>{state.positions_count}</dd></div>
        </dl>
      )}
    </div>
  );
}
